<template>
    <div>
        <input type="radio" :name="props.name" :value="props.value" :checked="isChecked" @change="cambiarEstado" :aria-label="id"
            :id="'radio_' + props.id" :disabled="props.disabled" class="hidden-radio" />
        <label :class="['radio-label', props.class]" :for="'radio_' + props.id">
            <span :class="['circle', { 'circle-checked': isChecked }]"></span>
            {{ props.label }}
        </label>
    </div>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue'

const props = defineProps({
    label: { type: String },
    id: { type: String },
    value: { type: String },
    name: { type: String },
    onClick: { type: Function },
    disabled: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
    class: { type: String },
})

const isChecked = ref(props.checked);

const cambiarEstado = () => {
    isChecked.value = !isChecked.value;
    if (props.onClick) {
        props.onClick()
    }
}
watch(() => props.checked, (newValue) => {
    isChecked.value = newValue;
});
</script>

<style>
.circle {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 1px solid #CDCED9;
    border-radius: 50%;
    margin-right: 8px;
    background-color: white;
}

.circle-checked {
    width: 8px;
    height: 8px;
    border: 5px solid #007A5E;
}

.hidden-radio {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

.radio-label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
}
</style>